goog.provide("shadow.js.shim.module$date_fns$endOfDay$default");
shadow.js.shim.module$date_fns$endOfDay$default = shadow.js.require(136, {}).default;
